import { render, staticRenderFns } from "./PasswordRestore.vue?vue&type=template&id=99bc100a&lang=pug"
import script from "./PasswordRestore.vue?vue&type=script&lang=js"
export * from "./PasswordRestore.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports